import { useState } from "react";
import { classNames } from "../lib/utils";

type DateTimeProps = {
    placeholder?: string;
    disabled?: boolean;
    value: string;
    id?: string;
    onChange?: (value: string) => void;
    onBlur?: () => void;
    autoFocus?: boolean;
}

export function DateTime(props: DateTimeProps) {
    const { placeholder, disabled, value, id, onChange, onBlur, autoFocus } = props;

    const [is_focused, setIsFocused] = useState<boolean>(false);

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
        onBlur?.();
    };

    return (
        <div className={classNames(
            "flex w-full rounded-md shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-inset focus-within:ring-space_blue-600 relative",
            disabled ? "bg-gray-100 cursor-not-allowed text-gray-500" : "bg-white text-gray-900"
        )}>
            <input
                id={id}
                type="datetime-local"
                className={classNames(
                    "block flex-1 min-w-0 border-0 bg-transparent p-2 focus:ring-0 sm:text-sm sm:leading-6",
                    disabled ? "cursor-not-allowed text-gray-500" : "text-gray-900"
                )}
                disabled={disabled}
                value={value}
                onChange={e => onChange?.(e.target.value)}
                onFocus={handleFocus}
                onBlur={handleBlur}
                autoFocus={autoFocus}
                style={{ colorScheme: 'light' }}
            />
            {!value && !is_focused && placeholder && (
                <div className="absolute inset-0 flex items-center px-2 pointer-events-none text-gray-400 text-sm bg-white rounded-md ring-1 ring-inset ring-gray-300">
                    {placeholder}
                </div>
            )}
        </div>
    );
}